import React, {useEffect, useRef, useState}  from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

//Get component for article route
import Articles from './components/Articles/Articles'

//Get component for article hub
import Hub from './components/Hub/Hub';
import Menu from './components/Shared/Menu/Menu';
import globalJson from 'data/content.json';

import { getFileList } from 'helpers/FileCaching';

const globalImages = require.context('./assets/images/global', true, /.*\.(gif|png|jpe?g|svg)$/i);
const heroImages = require.context('./assets/images/Hero', true, /.*\.(gif|png|jpe?g|svg)$/i);
var Preload = require('react-preload').Preload;


function App(props) {

    var loadingIndicator = (<div><h1>Made on Earth</h1><p style={{color:"white"}}>Loading...</p></div>);
    let heroImageNameList = getFileList(heroImages)

    let scroll25percentTracked = useRef(false);
    let scroll50percentTracked = useRef(false);
    let scroll75percentTracked = useRef(false);
    let scroll100percentTracked = useRef(false);
    let pereviousScrollPercentage = useRef(0)

    let [windowSize, setWindowSize] = useState('desktop');

    useEffect(() => {
      const onScroll = () => {
        heightOfPage();
      }
      const onResize = () => {
        if (window.innerWidth < 768) {
          setWindowSize('mobile');
        } else if(window.innerWidth < 1200) {
          setWindowSize('tablet');
        } else {
          setWindowSize('desktop');
        }
      }
      if(window){
        window.addEventListener('scroll', onScroll);
        window.addEventListener("resize", onResize);
      }

    }, []);

    useEffect(() => {
    }, [windowSize])
  const heightOfPage = () => {
  
    var body = document.body,
    html = document.documentElement;

    var height = Math.max( body.scrollHeight, body.offsetHeight, 
                       html.clientHeight, html.scrollHeight, html.offsetHeight );

   var scroll = window.scrollY //Modern Way (Chrome, Firefox) 
    || document.documentElement.scrollTop;

    var percentage = ((scroll+window.innerHeight)/height)*100;

    // to do tracking checks
    
    var minMaxPercentage = Math.min(100, Math.max(pereviousScrollPercentage.current, percentage));

    if(pereviousScrollPercentage.current<percentage){
      pereviousScrollPercentage.current = percentage;
      if(minMaxPercentage >= 25 && !scroll25percentTracked.current){

        window.gtag('event', "viewed hub",{
          'event_category': globalJson.tracking.ga_category,
                'event_label': "scroll 25% progress",
                'value':10
              	});

        scroll25percentTracked.current = true;

      }
      if(minMaxPercentage >= 50 && !scroll50percentTracked.current){

        window.gtag('event', "viewed hub",{
        'event_category': globalJson.tracking.ga_category,
              'event_label': "scroll 50% progress",
              'value':10
            	});

        scroll50percentTracked.current = true;

      }
      if(minMaxPercentage >= 75 && !scroll75percentTracked.current){

        window.gtag('event', "viewed hub",{
	 			'event_category': globalJson.tracking.ga_category,
	             'event_label': "scroll 75% progress",
	             'value':10
        });

        scroll75percentTracked.current = true;

      }
      if(minMaxPercentage >= 100 && !scroll100percentTracked.current){

        window.gtag('event', "viewed hub",{
        'event_category': globalJson.tracking.ga_category,
        'event_label': "scroll 100% progress",
        'value':10
        });

        scroll100percentTracked.current = true;

      }
    }
	}



  return (
    <Router>
    <div className="App">
        <Menu globalImages={globalImages}></Menu>
        <Switch>
        <Route exact path={`${process.env.PUBLIC_URL}(/index.html|/)`} render={({history}) => 
          <Hub history={history}></Hub>
        }/>
        </Switch>
        <Route path={`*/:articleTitle`} render={(props) => 
          <Articles globalImages={globalImages} windowSize={windowSize} globalContent={globalJson} {...props} >

          </Articles>
        }/>
   
    </div>
    </Router>
  );
}

export default App;
